import { CheckCircleIcon, TrashIcon } from "@heroicons/react/24/outline";
import React from "react";
import DocImage from "../../Assets/Images/doc.png";
import PDFImage from "../../Assets/Images/pdf.png";
import URLImage from "../../Assets/Images/url.png";
import Tooltip from "../../Components/UI/Tooltip/Tooltip";
import { useUserStore } from "../../Context/store";
import { useFileViewer } from "../../Context/FileViewerContext";
import { useWorkspaceStore } from "../../Context/store";
import { shadowBlue } from "../../Utils/Constant";
import { extractTitle, getFileType, getLocalTime } from "../../Utils/Helper";
import { useRemoveCitation } from "../../Web-Hooks/Debate/use-debate";
import VIDImage from "../../Assets/Images/video.png";
import { useDeleteBlob } from "../../Web-Hooks/LibraryAPI/use-citation";
import { setItem } from "../../Utils/localStorage";

const DebateCitationList = ({ citation, setCitation, argument, setAllCitation, allCitation }) => {
  const [citationValid] = React.useState({});
  const { mutateAsync: removeCitation } = useRemoveCitation();
  const { user: loggedInUser } = useUserStore();
  const { selectedWorkspace } = useWorkspaceStore();
  const { handleFile } = useFileViewer();
  const { mutateAsync: deleteBlob } = useDeleteBlob();

  // Function to handle deletion of a citation
  const handleCitationDelete = async (selectedCitation) => {
    const newCitation = citation.filter(
      (item) => item.citationUrl !== selectedCitation?.citationUrl
    );
    const newAllCitation = allCitation.filter(
      (item) => item.citationUrl !== selectedCitation?.citationUrl
    );
    setCitation(newCitation);
    setItem("Citation", newCitation);
    setAllCitation(newAllCitation);

    if (selectedCitation?.citationType !== "url") {
      const Blob = { fileUrl: selectedCitation?.citationUrl };
      await deleteBlob(Blob);
    }

    if (selectedCitation?.isCitationFromDatabase) {
      const citationToRemove = {
        CitationId: selectedCitation?.citationId,
        UserId: loggedInUser?.userId,
      };
      if (
        Object.values(citationToRemove).some(
          (item) => item === null || item === undefined || item === ""
        )
      ) {
        return;
      }
      removeCitation(citationToRemove);
    }
  };

  // Function to determine if an item is valid
  const isCitationValid = (item) => {
    // Replace with your actual validation logic
    return citationValid[item.citationUrl] || false;
  };

  const CitationListRender = (item) => {
    const fileType = getFileType(`hello.${item?.citationType}`);

    const Src =
      fileType === "doc"
        ? DocImage
        : fileType === "pdf"
        ? PDFImage
        : item?.citationType === "url"
        ? URLImage
        : fileType === "video"
        ? VIDImage
        : item?.citationUrl;

        const CitationTitle = item?.citationTitle ? item?.citationTitle : extractTitle(item?.citationUrl)
        ? extractTitle(item?.citationUrl)
        : item?.citationUrl;

    return (
      <Tooltip
        position="bottom"
        key={item?.citationUrl}
        content={item?.citationNote || "Description Not Available"}
        containerClass="!w-full"
        className="!w-full text-debatePalette-background bg-sideLayoutPrimary z-100"
      >
        <div
          className={`flex w-full cursor-pointer items-center px-3 py-2 gap-3 border rounded-md ${shadowBlue}`}
        >
          <img
            className="h-8 w-8 rounded-md object-cover object-center cursor-pointer"
            id="citationFile"
            src={Src}
            alt={item?.citationType}
            onClick={(e) => {
              e.preventDefault(); // Prevent default download behavior
              if (item?.citationType === "url") {
                window.open(item?.citationUrl, "_blank");
                return;
              }
              handleFile({
                fileUrl: item?.citationUrl,
                fileType: item?.citationType,
                fileName: CitationTitle,
                fileUploadedAt: getLocalTime(item?.createdAt),
                createdBy: loggedInUser?.userName,
                creatorImage: loggedInUser?.userImage,
                channelName: selectedWorkspace?.workSpaceName,
              });
            }}
          />{" "}
          <p className="truncate w-[60%]">{CitationTitle}</p>
          <div className="flex flex-1 justify-end items-center gap-2">
            <TrashIcon
              id="deleteCitation"
              className="h-6 w-6 text-debatePalette-timer opacity-50 hover:opacity-100"
              onClick={() => handleCitationDelete(item)}
            />
            {isCitationValid(item) && (
              <CheckCircleIcon color="green" className="h-7 w-7" />
            )}
          </div>
        </div>
      </Tooltip>
    );
  };

  return (
    <div className="flex flex-col py-2 gap-3 w-full">
      {citation?.map((item) => (
        <div className="flex flex-row gap-5 w-full" key={item?.citationUrl}>
          {CitationListRender(item)}
        </div>
      ))}
    </div>
  );
};

export default DebateCitationList;
